import circleImg from '../../../../../../imgs/circle1@2x.png';
import { Colors, PieLegendProp } from '.';

export const getPieChartOption = (total: number, pieLegendData?: PieLegendProp[]) => {
  return {
    color: Colors,
    legend: {
      show: false,
    },
    tooltip: {
      formatter: (param: any) => {
        return `
          <div style="margin-top:8px;width:max-content;">
            ${param.seriesName}
            <div style="display:flex;gap: 8px;align-items:center;">
            ${param.marker}<span>${param.name}</span><span>${param.data.data?.total}</span></div>
          </div>
        `;
      },
    },
    title: {
      text: total ?? '-',
      textStyle: {
        fontSize: 18,
        color: '#fff',
      },
      subtext: `总计`,
      subtextStyle: {
        fontSize: 14,
        color: 'rgba(255,255,255,0.65)',
      },
      left: 54,
      top: 36,
      itemGap: 4,
      textAlign: 'center',
    },
    graphic: {
      elements: [
        {
          type: 'image',
          style: {
            image: circleImg,
            x: 23,
            y: 23,
            width: 72,
            height: 72,
          },
          keyframeAnimation: [
            {
              // 动画时长，单位 ms
              duration: 3000,
              // 设置旋转动画是否循环
              loop: true,
              easing: 'linear',
              // 动画的关键帧
              keyframes: [
                {
                  // percent为关键帧的位置,0为第一个,1为最后一个
                  percent: 0,
                  rotation: 2 * Math.PI,
                  transition: ['rotation'],
                },
                {
                  percent: 1,
                  rotation: 0,
                  transition: ['rotation'],
                },
              ],
            },
          ],
          // 旋转的中心点
          origin: [59, 59],
        },
      ],
    },
    series: [
      {
        type: 'pie',
        name: `总计`,
        percentPrecision: 5,
        minAngle: 2,
        padAngle: 1,
        radius: [40, 50],
        left: 42,
        top: 42,
        width: 35,
        height: 35,
        label: {
          show: false,
        },
        data: pieLegendData?.map(i => ({ ...i, value: i.data?.total })),
        showEmptyCircle: false,
      },
      {
        showEmptyCircle: false,
        data: pieLegendData?.map(i => ({ ...i, value: i.data?.total })),
        type: 'pie',
        percentPrecision: 5,
        padAngle: 1,
        minAngle: 2,
        left: 30,
        top: 30,
        name: `总计`,
        radius: [50, 60],
        width: 60,
        height: 60,
        label: {
          show: false,
        },
        emphasis: {
          disabled: true,
        },
        itemStyle: {
          opacity: 0.3,
        },
      },
    ],
  };
};
